import { assertNever } from '@/lib/typescript/assertNever'
import {
  GetSearchResultDocument,
  ProductListBrandPageDocument,
  ProductListCategoryProductsDocument,
  ProductListEventProductsDocument,
  type ProductListTemplate_ProductListFragment,
} from '@gql-generated/graphql'
import type { ProductListProductsQueryData, QueryKey } from './productList.types'

function getProductListFromSearchList(
  data: ProductListProductsQueryData,
): ProductListTemplate_ProductListFragment | null {
  if ('searchList' in data) {
    return data.searchList?.productList ?? null
  }

  return null
}

function getProductListFromCategories(
  data: ProductListProductsQueryData,
): ProductListTemplate_ProductListFragment | null {
  if ('categories' in data && data.categories?.length) {
    return data.categories[0]?.productList ?? null
  }

  return null
}

function getProductListFromBrand(
  data: ProductListProductsQueryData,
): ProductListTemplate_ProductListFragment | null {
  if ('brand' in data) {
    return data.brand?.productList ?? null
  }

  return null
}

function getProductListFromEvent(
  data: ProductListProductsQueryData,
): ProductListTemplate_ProductListFragment | null {
  if ('event' in data) {
    return data.event?.productList ?? null
  }

  return null
}

export function getProductListByQueryKey(data: ProductListProductsQueryData, queryKey: QueryKey) {
  if (queryKey === 'searchList') {
    return getProductListFromSearchList(data)
  } else if (queryKey === 'categories') {
    return getProductListFromCategories(data)
  } else if (queryKey === 'brand') {
    return getProductListFromBrand(data)
  } else if (queryKey === 'event') {
    return getProductListFromEvent(data)
  } else {
    assertNever(queryKey)
  }
}

export function getQueryDocumentByQueryKey(queryKey: QueryKey) {
  if (queryKey === 'searchList') {
    return GetSearchResultDocument
  } else if (queryKey === 'categories') {
    return ProductListCategoryProductsDocument
  } else if (queryKey === 'brand') {
    return ProductListBrandPageDocument
  } else if (queryKey === 'event') {
    return ProductListEventProductsDocument
  } else {
    assertNever(queryKey)
  }
}
